<template>
  <div class="comment" v-loading="loading">
    <el-row v-show="DefaultShowInput">
      <div class="title">
        <i class="iconfont icon-zxfz-dxys pingjia"></i>
        &nbsp;评论【{{ commentList.length }}条】
        <el-link
          v-show="ShowLink"
          type="primary"
          style="font-size:16px;margin-left:20px"
          @click.native="gotoDetail"
          >前往详情</el-link
        >
      </div>
      <el-divider></el-divider>
    </el-row>
    <el-row
      v-for="(comment, index) in commentList"
      :key="index"
      style="padding-top: 5px;"
    >
      <div class="comment-detail">
        <div class="nameImg">
          <el-avatar style="background: goldenrod;" size="large">
            {{ comment.CREATEUSERNAME.substr(0, 1).toUpperCase() }}
          </el-avatar>
        </div>
        <div class="title1">
          <div style="margin-bottom: 5px;">
            <span class="name">{{ comment.CREATEUSERNAME }}</span>
          </div>
          <p class="comment-content" v-html="comment.CONTENT"></p>
          <div class="comment-line"></div>
          <div class="parent-comment" v-show="comment.TOUSERID">
            <div>
              <span style="margin-right: 5px">回复</span>
              @{{ comment.TOUSERNAME }}
            </div>
            <p v-html="getParentComment(comment.PID)"></p>
            <div class="comment-line"></div>
          </div>

          <div class="time-div">
            {{
              comment.CREATETIME.replace("T", " ")
                .replace("Z", "")
                .split(".")[0]
            }}
            <span class="reply" style="cursor:Pointer" @click="reply(comment)"
              >回复</span
            >
            <span
              class="delcomment"
              v-show="isMyComment(comment.CREATEUSERID)"
              @click="delComment(comment)"
              >删除</span
            >
          </div>
          <fileListView
            :fileList="comment.FileList"
            v-show="comment.FileList | (comment.FileList.length > 0)"
            style="margin-top:5px;border: 1px dashed gray;padding: 5px;"
            :isFlex="true"
            :idIsUrl="false"
            :isEdit="false"
          ></fileListView>
          <!-- <div class="time"></div> -->
        </div>
      </div>
      <div
        :class="{
          'el-divider': true,
          'el-divider--horizontal': true,
          'divider-hidden': index == commentList.length - 1
        }"
      ></div>
      <!-- <el-divider class="divider-hidden"></el-divider> -->
    </el-row>
    <AddComment
      ref="addComment"
      :MainId="MainId"
      :Type="Type"
      v-if="showInput"
      @addComment="addSuccess"
      @cancelComment="cancelSuccess"
    ></AddComment>
  </div>
</template>

<script>
import {
  GetCrisitismByMainId,
  DelCrisitism
} from "@/api/modules/basicData/task";
import fileListView from "@/components/common/fileListView.vue";
import AddComment from "./AddComment.vue";
import { mapState } from "vuex";
export default {
  components: {
    fileListView,
    AddComment
  },
  data() {
    return {
      commentList: [], //评论集合
      rootData: [], //非回复集合
      ReplyData: [], //回复集合
      showInput: true,
      loading: false
    };
  },
  props: {
    MainId: String,
    Type: {
      type: [Number, String],
      default: 0
    },
    TopNum: String,
    ShowLink: Boolean,
    DefaultShowInput: {
      //默认显示输入框
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      ServerCenterIds: state => state.task.ServerCenterIds,
      createIdentity: state => state.task.createIdentity,
      contactId: state => state.user.ContactID,
      realName: state => state.task.realName,
      departmentId: state => state.user.departmentId,
      departmentName: state => state.user.departmentName,
      companyId: state => state.user.companyId,
      companyName: state => state.user.companyName,
      organizationId: state => state.user.organizationId
    })
  },

  methods: {
    cancelSuccess() {
      this.showInput = this.DefaultShowInput;
      this.$emit("cancelSuccess");
    },
    addSuccess() {
      this.initialTask();
      this.$emit("addCommentSuccess");
    },
    isMyComment(id) {
      return id == this.userId;
    },
    gotoDetail() {
      if (this.Type == 0) {
        let url = `${location.href.substr(
          0,
          location.href.lastIndexOf("/")
        )}/task-detailspage?taskid=${this.MainId}`;
        window.open(url);
      } else if (this.Type == 1) {
        let url = `${location.href.substr(
          0,
          location.href.lastIndexOf("/")
        )}/recordinfo?recordid=${this.MainId}`;
        window.open(url);
      }
    },
    getParentComment(pid) {
      let row = this.commentList.filter(item => item.ID === pid);
      if (row && row.length > 0) {
        return row[0].CONTENT;
      }
      return "";
    },
    reply(data) {
      this.showInput = true;
      this.$refs.addComment.reply(data);
    },
    delComment(model) {
      this.$confirm("确认删除？").then(_ => {
        var obj = Object.assign({}, model);
        obj.FileList = null;
        DelCrisitism(obj)
          .then(result => {
            if (result.ResultCode > 0) {
              this.initialTask();
              this.$emit("delCommentSuccess");
              this.$message({
                type: "success",
                message: "删除评论成功。"
              });
            } else {
              this.$message({
                type: "error",
                message: "删除评论失败！"
              });
            }
          })
          .catch(_ => {});
      });
    },
    initialTask() {
      this.showInput = this.DefaultShowInput;
      if (this.MainId) {
        this.loading = true;
        GetCrisitismByMainId(this.MainId, this.Type, this.TopNum).then(
          result => {
            if (!result) return;
            this.commentList = result;
            this.rootData = result.filter(item => item.ROOTID === null);
            this.ReplyData = result.filter(item => item.ROOTID != null);
            this.loading = false;
          }
        );
      }
    }
  },
  mounted() {},
  watch: {
    DefaultShowInput: {
      handler(newValue, oldval) {
        console.log("DefaultShowInput", this.showInput);
        this.showInput = newValue;
      },
      immediate: true
    },
    MainId(newval) {
      if (newval) {
        console.log("watch", newval);
        this.initialTask();
      }
    }
    // MainId: {
    //   handler(newval, oldval) {
    //     if (newval) {
    //       console.log(`initialTask MainId newval=${newval} oldval=${oldval}`);
    //       this.initialTask();
    //     }
    //   },
    //   immediate: true
    // }
  }
};
</script>

<style lang="less" scoped>
@border-color: #d5dae6;

.divider-hidden {
  background: transparent !important;
}

.comment {
  margin-top: 5px;

  .pingjia {
    color: #70c063;
    font-size: 16px;
    font-weight: bolder;
  }

  .title {
    font-size: 17px;
    font-weight: 500;
  }

  .comment-detail {
    display: flex;
    margin-left: 5px;

    // margin-bottom: 5px;
    // border-bottom: 1px solid @border-color;
    .title1 {
      margin-left: 10px;
      margin-bottom: 5px;
      box-sizing: border-box;

      .time-div {
        font-size: 12px;
        color: #999;

        .reply {
          margin-left: 15px;
          // color: #67c23a;
          color: #2b7cff;
        }
      }
    }

    .nameImg {
      // height: 40px;
      // width: 40px;
      // border-radius: 50%;
      // margin-top: 10px;
      // background-color: #809cec;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // .text {
      //   color: #fff;
      // }
    }
  }

  .name {
    color: #2b7cef;
    font-weight: bold;
    font-size: 13px;
  }

  .content {
    font-size: 16px;
    // word-wrap: break-word;
    // word-break: break-all;
  }

  .comment-content {
    font-size: 14px;
    width: 100%;
    // word-break: break-all;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
    // overflow: hidden;
  }

  .parent-comment {
    color: #929baa;
    font-size: 13px;
  }

  .comment-line {
    height: 5px;
  }

  .commentText {
    font-size: 14px;
    color: #929baa;
  }

  .time {
    font-size: 12px;
    color: #929baa;
  }
}

.delcomment {
  margin-left: 5px;
  cursor: Pointer;
  color: coral;
}
</style>
<style scoped>
.comment >>> .el-divider--horizontal {
  margin: 5px 0;
}
</style>
